import {observable} from 'mobx';

export class SmsStatusModalState {
    @observable isVisible: boolean = false;
    @observable title: string = '';
    @observable message: string = '';
    @observable question: boolean = false;
    @observable useNewInterfaceOverride: boolean | undefined = undefined;
    @observable isMobileValue: boolean = false;
}
